import { FC, memo } from 'react'
import styled, { useTheme } from 'styled-components'
import { StyledDivider } from '@/components/common/divider'
import { Typo, TypoVariant } from '@/components/common/typography'
import ListProductSliderV2 from '@/components/domains/list/list-product-slider-v2'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { useGetCartData } from '@/containers/hooks/cart/useGetCartData'
import { useRecommendedCartProductsQuery } from '@/graphql/generated/hooks'
import { Base64ConverterUtil } from '@/utils/base64-converter.util'
import { GraphQLProductType } from '@/utils/product/product-card.util'

type CartRecommendedProductsProps = {
  cartProductOptionsIdInCart: number[]
}

const CartRecommendedProductsV2: FC<CartRecommendedProductsProps> = ({ cartProductOptionsIdInCart }) => {
  const { color } = useTheme()
  const { data, loading: isLoading } = useRecommendedCartProductsQuery({
    fetchPolicy: 'no-cache',
    variables: {
      ids: cartProductOptionsIdInCart.map((id) =>
        Base64ConverterUtil.convertNumberIdToBase64ByKey({
          key: 'ProductOptionType',
          id,
        })
      ),
    },
    skip: !cartProductOptionsIdInCart.length,
  })

  const { getCartDataByChecked, updateCartDataParamsWithNewIds } = useGetCartData()
  const products = (data?.recommendedCartProducts?.edges.map((item) => item.node) as GraphQLProductType[]) || []

  if (!isLoading && !products.length) {
    // 추천상품 갯수가 0개라면 컴포넌트가 null 리턴
    return null
  }

  return (
    <>
      <StyledDivider height="0.1rem" backgroundColor={color.gray70} />
      <StyledContainer>
        <StyledTitle>
          <Typo variant={TypoVariant.Heading6Bold}>함께 구매하면 좋은 상품</Typo>
        </StyledTitle>
        <ListProductSliderV2
          products={products}
          isLoading={isLoading}
          addToCartCallback={(ids) => {
            if (ids) {
              getCartDataByChecked({ param: updateCartDataParamsWithNewIds(ids), enabledUpdateCartCount: false })
            }
          }}
        />
      </StyledContainer>
      <StyledDivider height="0.1rem" margin="2.4rem 0 0 0" backgroundColor={color.gray70} />
    </>
  )
}

const StyledContainer = styled.div`
  position: relative;
  background-color: ${GlobalColorEnum.GrayWhite};
  overflow: hidden;
`

const StyledTitle = styled.div`
  padding: 1.6rem;
`

export default memo(CartRecommendedProductsV2)
